import React, { FunctionComponent } from 'react';
import { useLocale } from '../../contexts/LocaleProvider';
import { IntlProvider } from 'react-intl';
import { Box } from '@mui/material';
import DistributorPortalHome from './DistributorPortalHome';

interface DistributorPortalPageProps {}

const DistributorPortalPage: FunctionComponent<DistributorPortalPageProps> = ({}) => {
    const { locale, messages } = useLocale();

    return (
        <IntlProvider locale={locale} key={locale} defaultLocale="en" messages={messages}>
            <Box
                width="100%"
                component="main"
                sx={{
                    padding: 0,
                    flexGrow: 0,
                    p: 0, // 内边距
                }}
            >
                <DistributorPortalHome />
            </Box>
        </IntlProvider>
    );
};

export default DistributorPortalPage;
